'use client'

import { useMemo } from 'react'

export const useIsWindows = () => {
  const isWindows = useMemo(() => {
    if (typeof navigator === 'undefined') {
      return false
    }
    const userAgent = navigator.userAgent.toLowerCase()
    return (
      userAgent.includes('windows') ||
      navigator.userAgent.includes('win64') ||
      navigator.userAgent.includes('win32')
    )
  }, [])
  return { isWindows }
}
